<template>
    <div>
        <CCard class="w-100">
            <CCardHeader>
                <strong>{{$t('MenuItem.SysLogFile')}}</strong>
            </CCardHeader>
            <CCardBody>
                <div class="CForminline">
                    <div class="date_range">
                        <p>{{$t('SearchBar_Vue.DateRange')}}：</p>
                        <date-picker :lang="'zh-tw'" format="YYYY-MM-DD" valueType="format" v-model="queryParam.dateBegin"></date-picker>
                        <span>~</span>
                        <date-picker :lang="'zh-tw'" format="YYYY-MM-DD" valueType="format" v-model="queryParam.dateEnd"></date-picker>                        
                        <p><button type="button" class="btn btn-edit btn-dark" @click="queryEvent">{{$t('Buttons.Query')}}</button></p>
                    </div>
                    
                </div>
            </CCardBody>
        </CCard>
        <CCard>
            <CCardBody class="scroll">
                <table class="table ">
                    <thead class="thead-light">
                        <tr>
                            <th class="text-center">日期</th>
                            <th class="text-center">下載</th>                             
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in logFilesSearchResult" :key="index">
                            <td class="text-center">{{item.dateTxt}}</td>
                            <td class="text-center"><a :href="getDownloadLink(item.dateTxt)" download="download" target="_blank">DownLoad</a></td>                            
                        </tr>
                    </tbody>
                </table>
            </CCardBody>
        </CCard>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    mixins: [],	
    data() {
        return {
            headers : [
            ],
            logFilesSearchResult : [],
            queryParam : {
                dateBegin: new Date().addDays(-14).yyyymmdd(),//近15天的日期區間，即[系統當日-15+1]~[系統當日]
                dateEnd: new Date().yyyymmdd()
            }
        }
    },
    props : {
    },
    watch: {
        
    },
    methods: {
        checkSearchParam(){ //檢核條件
           const {dateBegin,dateEnd} =this.queryParam;
           let errMsg = '';
           if(dateBegin && dateEnd){
               if(dateBegin>dateEnd){
                 errMsg='日期區間錯誤，起始日不得大於終止日!';
               }
           }                   
           if(errMsg){
                this.$alert(errMsg , '警告',{type: 'warning'});
                return false;
           }
           return true;
        },
        queryEvent (){
            if(this.checkSearchParam()){
                const {dateBegin,dateEnd} =this.queryParam;
                this.logFilesSearchResult = [];
                const url = `${this.$apiUrl_SysMenuItem}/QueryDownloadLogList?startDate=${dateBegin}&endDate=${dateEnd}`;
                    this.axios.get(url).then((response) => {                        
                    const rows = response.data;     
                    const list = [];            
                    rows.forEach(logName => {
                        
                        list.push({dateTxt : logName.replace('.log','') ,fileTxt: logName});
                    });
                    this.logFilesSearchResult = list;
                })
            }
        },
        getDownloadLink (v){
           if(v){
               const url = `${this.$apiUrl_SysMenuItem}/DownloadLog?keyId=${v}`;
               return url ;
           }
           return '#';
        }
    },
    computed: {
        ...mapGetters(["lang"]),
        isAllow (){
            const userInfo = this.$userInfo ;            
            if(userInfo && userInfo.allowRouterNameList){
                if(userInfo.allowRouterNameList.includes('SysLogFile')){
                    return true;
                }
            }
            return false;
        } 
    },
	mounted() {        
        if(!this.$isAdmin || !this.isAllow){           
           location.reload();
        }
	},
    created() {        
    }
}
</script>
<style lang="scss" scoped>
.CForminline {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    > .form-group {
        margin-bottom: 0;
    }

    > .date_range, .number_range, .quotation_class, .purchase, .closure {
        display: flex;
        align-items: center;
        margin: .5rem 0;
        > p {
            margin-right: 1rem;
            margin-bottom: 0;
        }
        > .purchase_input {
            margin-bottom: 0;
        }
        > input {
            margin: 0 .5rem;
        }
        > div {
            margin: 0 .5rem;
        }
    }
}

</style>




